import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import Footer from '@/components/Footer.vue';
import ToggleDark from '@/components/ToggleDark.vue';
import LanguageSwitcher from '@/components/LanguageSwitcher.vue';
import Logo from '@/components/Logo.vue';
import { mapGetters } from 'vuex';
import backgroundManager from '@/mixins/backgroundManager';
export default {
  name: 'BaseLogin',
  mixins: [backgroundManager],
  props: {
    // 页面标题
    title: {
      type: String,
      required: true
    },
    // 输入字段配置
    fields: {
      type: Array,
      required: true
      // fields 格式: [{ key: 'username', label: '用户名', placeholder: '请输入用户名', type: 'text', showPassword: false }]
    },
    // 提交按钮文本
    submitText: {
      type: String,
      default: ''
    },
    // 背景图配置键名
    backgroundKey: {
      type: String,
      required: true
    },
    // 是否为管理端登录（影响背景样式）
    isAdmin: {
      type: Boolean,
      default: false
    },
    // 是否正在加载
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formData: {},
      labelUnderlineWidths: [],
      isFocused: false,
      viewportHeight: 0
    };
  },
  computed: {
    ...mapGetters(['userConfig']),
    computedSubmitText() {
      return this.submitText || this.$t('login.submit');
    },
    viewportStyle() {
      // 当检测到虚拟键盘弹出时，将容器高度收缩到可见视口高度
      // 容器本身 flex 居中，高度缩小后登录卡片自然在可见区域内居中
      if (this.viewportHeight > 0) {
        return {
          height: `${this.viewportHeight}px`,
          minHeight: `${this.viewportHeight}px`
        };
      }
      return {};
    }
  },
  watch: {
    fields: {
      handler() {
        this.$nextTick(() => {
          this.calculateLabelWidths();
        });
      },
      deep: true
    }
  },
  components: {
    Footer,
    ToggleDark,
    LanguageSwitcher,
    Logo
  },
  mounted() {
    // 初始化表单数据
    this.initFormData();
    // 初始化背景图
    this.initializeBackground(this.backgroundKey, '.login', !this.isAdmin, true);
    // 在下一个tick计算标签宽度，确保DOM已经渲染
    this.$nextTick(() => {
      this.calculateLabelWidths();
    });
    // 监听 visualViewport 变化，检测虚拟键盘弹出
    this._handleViewportResize = this.handleViewportResize.bind(this);
    if (window.visualViewport) {
      this._initialHeight = window.visualViewport.height;
      window.visualViewport.addEventListener('resize', this._handleViewportResize);
    }
  },
  beforeDestroy() {
    if (window.visualViewport && this._handleViewportResize) {
      window.visualViewport.removeEventListener('resize', this._handleViewportResize);
    }
  },
  methods: {
    initFormData() {
      // 根据字段配置初始化表单数据
      const newFormData = {};
      this.fields.forEach(field => {
        newFormData[field.key] = '';
      });
      this.formData = newFormData;
      // 初始化下划线宽度数组
      this.labelUnderlineWidths = new Array(this.fields.length).fill(0);
    },
    calculateLabelWidths() {
      // 计算每个标签的文字宽度
      this.$nextTick(() => {
        this.fields.forEach((field, index) => {
          const labelRef = this.$refs[`inputLabel${index}`];
          if (labelRef && labelRef[0]) {
            // 创建一个临时的canvas来测量文字宽度
            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');

            // 获取标签的计算样式
            const labelElement = labelRef[0];
            const computedStyle = window.getComputedStyle(labelElement);

            // 设置font样式以匹配标签
            context.font = `${computedStyle.fontWeight} ${computedStyle.fontSize} ${computedStyle.fontFamily}`;

            // 测量文字宽度
            const textWidth = context.measureText(field.label).width;

            // 添加一些额外的边距，确保下划线覆盖整个文字
            this.labelUnderlineWidths[index] = Math.ceil(textWidth) + 3;
          }
        });
      });
    },
    handleSubmit() {
      if (this.loading) return;
      // 触发父组件的提交事件，传递表单数据
      this.$emit('submit', {
        ...this.formData
      });
    },
    handleViewportResize() {
      if (!window.visualViewport) return;
      const currentHeight = window.visualViewport.height;
      // 键盘高度 = 初始视口高度 - 当前视口高度
      const keyboardHeight = this._initialHeight - currentHeight;
      // 设定阈值：视口缩小超过 150px 才认为是虚拟键盘弹出
      // 避免地址栏收缩等小幅变化误触发
      const KEYBOARD_THRESHOLD = 150;
      if (keyboardHeight > KEYBOARD_THRESHOLD) {
        // 将容器高度设为当前可见视口高度
        // flex 居中会让登录卡片自然在可见区域内居中，不会顶部溢出或底部留白
        this.viewportHeight = currentHeight;
      } else {
        this.viewportHeight = 0;
      }
    },
    handleInputFocus(event) {
      this.isFocused = true;
      const container = event.target.closest('.input-container');
      if (container) {
        const wrapper = container.querySelector('.input-wrapper');
        if (wrapper) {
          wrapper.classList.add('focused');
        }
      }
    },
    handleInputBlur(event) {
      this.isFocused = false;
      const container = event.target.closest('.input-container');
      if (container) {
        const wrapper = container.querySelector('.input-wrapper');
        if (wrapper) {
          wrapper.classList.remove('focused');
        }
      }
    }
  }
};